import { Component, Input } from '@angular/core';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-copy',
  templateUrl: './copy.component.html',
  styleUrls: ['./copy.component.scss']
})
export class CopyComponent {

  @Input()
  value = "";

  constructor(private readonly dataService: DataService) {
  }


  clickCopy() {
    this.dataService.copyValueAlert();
  }

}
